import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";

import { fetchProtocol } from "@/composables/getProtocolByID";
import { Protocol } from "@/models/Protocol";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  protocolID: { type: String, required: true },
},
  async setup(__props) {

let __temp: any, __restore: any

const props = __props



const selectedProtocol = ref<Protocol>(new Protocol());
selectedProtocol.value = (
  ([__temp,__restore] = _withAsyncContext(() => fetchProtocol(props.protocolID))),
  __temp = await __temp,
  __restore(),
  __temp
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, "Analytics Coming Soon"))
}
}

})